<template>
  <div id="new-site-modal-wrapper">
    <div class="card p-5" v-click-outside="closeModal">
      <button
        type="button"
        class="close"
        data-dismiss="card"
        aria-label="Close"
        @click="closeModal"
      >
        <span aria-hidden="true">×</span>
      </button>

      <div class="text-center">
        <img src="../assets/logo.svg" class="modal-logo mt-5 mb-5" alt="..." />
      </div>
      <h2 class="font-weight-bold text-center mb-5" id="modalExampleTitle">
        Welcome<br />to the new Neeman Foundation website
      </h2>
      <p class="text-muted">
        Please feel free to view the large variety of vital projects that you
        can help support
      </p>
      <p class="text-muted" v-if="$store.state.country == 'us'">
        If you have a charity that is supported by North American donors, please
        feel free to <a href="/join-us">JOIN US</a>
      </p>
      <p class="text-muted">
        If you are the owner of a charity/Amuta on our site, please
        <a href="/contact">CONTACT US</a>
        for user information
      </p>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    closeModal() {
      this.$store.state.showNewModal = false;
    },
  },
};
</script>
<style lang="scss">
#new-site-modal-wrapper {
  position: fixed;
  display: flex;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  z-index: 10000;
  backdrop-filter: blur(4px);
  justify-content: center;
  align-items: center;
  .modal-logo {
    width: 50px;
    margin: 0 auto 20px;
  }
  .card {
    display: block;
    width: 400px;
    max-width: 90vw;
    max-height: 90vh;
    pointer-events: auto;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(22, 28, 45, 0.2);
    border-radius: 0.5rem;
    box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.3);
    outline: 0;
  }
}
</style>